import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UserDetails from '../../components/Users/UserDetails';
import FriendList from '../../components/Users/FriendList';
import UserReviews from '../../components/Users/UserReviews';
import Dashboard from '../../components/Dashboard';
import { 
  getUserDetail,
  getUserReviews,
  getUserFriends
} from '../../redux/modules/user/action';

const ROWS_PER_PAGE = 10;

class ViewUser extends React.Component {
  state = {
    page: 0,
    rowsPerPage: ROWS_PER_PAGE
  };

  componentDidMount () {
    const { dispatch, match } = this.props;
    const { page, rowsPerPage } = this.state;

    dispatch(getUserDetail(match.params.userId));
    dispatch(getUserReviews(match.params.userId));
    dispatch(getUserFriends(match.params.userId, page, rowsPerPage));
  }

  handleChangePage = (event, page) => {
    const { dispatch, match } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({ page });
    dispatch(getUserFriends(match.params.userId, page, rowsPerPage));
  };

  handleChangeRowsPerPage = event => {
    const { dispatch, match } = this.props;
    const { page } = this.state;
    this.setState({ rowsPerPage: event.target.value });
    dispatch(getUserFriends(match.params.userId, page, event.target.value));
  };

  getUserTypes = (roleId) => {
    const { userTypes } = this.props;
    const role = userTypes.find(u => u.roleId === roleId);
    if (role) {
      return role.roleType;
    }
  }

  render () {
    const { 
      details = {}
    } = this.props;
    const { page, rowsPerPage } = this.state;

    const userType = this.getUserTypes(details.roleId);

    return (
      <Dashboard>
        <UserDetails details={details} userType={userType}/>
        <FriendList 
          list={details.friends ? details.friends.rows : []}
          totalRecords={details.friends ? details.friends.count : 0}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
        />
        <UserReviews 
           list={details.reviews || []}
        />
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    details: state.user.details,
    isVerified: state.user.details && state.user.details.isVerified,
    isActive: state.user.details && state.user.details.isActive,
    profileImage: state.user.details && state.user.details.image,
    message: state.user.message,
    userTypes: state.user.userTypes
  }
}

ViewUser.propTypes = {
  initialValues: PropTypes.object,
  isVerified: PropTypes.bool,
  isActive: PropTypes.bool,
  details: PropTypes.object
}

ViewUser.defaultProps = {
  isVerified: false,
  isActive: false
}

export default connect(mapStateToProps)(ViewUser);
